
export const TitanRace4 = () => {
    return (
        <>
            <ul>
                <li>Princess Races este o secțiune dedicată turneelor organizate de Princess Casino sau de partenerii
                    furnizori de jocuri.
                </li>
                <li>Promoţia este disponibilă unui grup de jucători premium ai platformei Princess Casino.
                    Închiderea/Suspendarea/Restricționarea contului din orice motive descalifică utilizatorul din
                    promoție.
                </li>
                <li>Închiderea/Suspendarea/Restricționarea contului din orice motive descalifică utilizatorul din
                    promoție.
                </li>
                <li>CURSA TITANILOR se desfășoară de la data de 21 Aprilie 2021, orele 00:00, până la data de 30 Aprilie
                    2021, orele 23:59.
                </li>
            </ul>
            <p><strong>Participare</strong></p>
            <ul>
                <li>Sunt eligibile pentru această cursă toate sloturile, precum și jocurile din categoria “Cazinou
                    Virtual”.
                </li>
                <li>Aduni puncte pe baza multiplicatorului fiecărei runde câștigate. De exemplu: dacă pariezi 20 RON și
                    câștigi 50 RON, vei primi 2,5 puncte.
                </li>
                <li>Punctele se obțin doar la câștiguri mai mari sau egale cu miza.</li>
                <li>Pariul minim pentru această cursă este de 20 RON.</li>
                <li>Punctajul unui jucător este suma tuturor multiplicatorilor obținuți la jocurile eligibile, din
                    pariuri realizate cu bani cash, în perioada desfășurării competiției.
                </li>
            </ul>
            <p><strong>Premii</strong></p>
            <span>Poți obține un premiu în două feluri:</span>
            <p><strong>Premii instant</strong></p>
            <ul>
                <li>În fiecare zi, sunt acordate 3 de premii a câte 1,000 RON. Premiile sunt acordate aleatoriu, zilnic
                    la orele: 16:00, 19:00 și 22:00.
                </li>
                <li>Pentru a fi eligibil pentru premiul instant un jucător trebuie să obțină minim 10 puncte în ziua
                    respectivă (după ora 00.00 și până la ora 23:59 a zilei în curs).
                </li>
            </ul>
            <p><strong>Premii CASH</strong></p>
            <ul>
                <li>Adună cât mai multe puncte și califică-te în top 20 pentru unul dintre premiile cash:</li>
            </ul>
            <div className="terms-table">
                <div className="terms-table-header">
                    <div className="terms-table-row">
                        <div className="terms-table-data"><strong>Locul</strong></div>
                        <div className="terms-table-data"><strong>Premii</strong></div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">1</div>
                        <div className="terms-table-data">25,000 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">2</div>
                        <div className="terms-table-data">20,000 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">3</div>
                        <div className="terms-table-data">12,000 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">4</div>
                        <div className="terms-table-data">10,000 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">5</div>
                        <div className="terms-table-data">7,000 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">6</div>
                        <div className="terms-table-data">6,000 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">7</div>
                        <div className="terms-table-data">5,000 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">8</div>
                        <div className="terms-table-data">4,000 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">9</div>
                        <div className="terms-table-data">3,000 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">10</div>
                        <div className="terms-table-data">2,000 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">11-15</div>
                        <div className="terms-table-data">1,000 RON</div>
                    </div>
                    <div className="terms-table-row">
                        <div className="terms-table-data">16-20</div>
                        <div className="terms-table-data">200 RON</div>
                    </div>
                </div>
            </div>
            <ul>
                <li>Premiile vor fi acordate în balanța jucătorului, în următoarele 48 de ore de la încheierea
                    competiției.
                </li>
                <li>Jucătorii vor fi anunțați pe email sau SMS când după realizarea creditării premiului</li>
                <li>În cazul în care este egalitate de puncte între doi jucători, suma totală rulată va fi folosită ca
                    un criteriu de departajare. În situația în care este egalitate perfectă de puncte și de sumă totală
                    rulată pe perioada promoției, premiul va fi împărțit între jucători.
                </li>
                <li>În cazuri de deconectare sau de probleme tehnice generale, toate rotirile afectate sunt anulate și
                    excluse din promoție în scopuri de punctaj.
                </li>
                <li>Oferta respectă Termenii și Condițiile Princess Casino.</li>
                <li>Princess Casino își rezervă dreptul de a suspenda promoția pentru unul sau pentru toți jucătorii,
                    fără explicații sau notificări prealabile, dacă promoția este folosită într-o manieră ce contravine
                    Regulilor Organizatorului. În cazul unui litigiu cu un jucător, decizia Organizatorului va prevala.
                </li>
                <li>Princess Casino își rezervă dreptul de a exclude jucătorii care participă la promoții cu conturi
                    multiple.
                </li>
                <li>Princess Casino își rezervă dreptul de a anula sau modifica termenii și condițiile acestei oferte
                    fără notificare prealabilă.
                </li>
                <li>Pentru orice întrebări legate de prezenta promoție, utilizatorii sunt rugați să contacteze echipa de
                    asistență la adresa de e-mail <a
                        href="mailto:contact@princesscasino.ro">contact@princesscasino.ro</a>.
                </li>
            </ul>
        </>
    )
}